import { MARQUEE_ITEMS } from "@/lib/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      aria-hidden="true"
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-[color:var(--line-strong)] bg-[color:var(--bone)] py-8 md:py-12"
    >
      <div className="relative overflow-hidden">
        <div className="marquee-track flex gap-[10vw] whitespace-nowrap will-change-transform">
          {items.concat(items).map((w, i) => (
            <span
              key={i}
              className="font-serif text-[64px] sm:text-[96px] md:text-[128px] leading-none tracking-[-0.04em] text-[color:var(--ink)] italic font-normal"
            >
              {w}
              <span className="mx-[3vw] text-[color:var(--copper)] not-italic font-serif">
                ✦
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
